// ABOUTME: Modal shown when unverified email users attempt to login
// ABOUTME: Provides resend verification functionality and clear instructions

import React, { useState } from 'react';
import './EmailVerificationModal.css';

const EmailVerificationModal = ({ isOpen, onClose, userEmail, onResendVerification }) => {
  const [isResending, setIsResending] = useState(false);
  const [resendMessage, setResendMessage] = useState('');
  const [resendSuccess, setResendSuccess] = useState(false);

  if (!isOpen) return null;

  const handleResend = async () => {
    setIsResending(true);
    setResendMessage('');

    try {
      await onResendVerification(userEmail);
      setResendSuccess(true);
      setResendMessage('E-mail de verificação enviado! Verifique sua caixa de entrada.');

      // Clear message after 5 seconds
      setTimeout(() => {
        setResendMessage('');
      }, 5000);
    } catch (error) {
      setResendSuccess(false);
      setResendMessage('Erro ao enviar e-mail. Tente novamente.');

      // Clear error after 5 seconds
      setTimeout(() => {
        setResendMessage('');
      }, 5000);
    } finally {
      setIsResending(false);
    }
  };

  return (
    <div className="verification-modal-overlay" onClick={onClose}>
      <div className="verification-modal" onClick={(e) => e.stopPropagation()}>
        <div className="verification-icon">📧</div>

        <h2>Verifique Seu E-mail</h2>

        <p className="verification-main-text">
          Você precisa verificar seu endereço de e-mail antes de fazer login.
        </p>

        <div className="verification-info-box">
          <p>
            <strong>E-mail:</strong> {userEmail}
          </p>
          <p>
            Enviamos um link de verificação para este endereço. Por favor, verifique sua caixa de entrada (e spam) e clique no link.
          </p>
          <p className="expiry-notice">
            ⏰ <strong>Atenção:</strong> O link expira em 2 horas.
          </p>
        </div>

        {resendMessage && (
          <div className={`verification-message ${resendSuccess ? 'success' : 'error'}`}>
            {resendMessage}
          </div>
        )}

        <button
          onClick={handleResend}
          disabled={isResending}
          className="btn-secondary resend-btn"
        >
          {isResending ? 'Enviando...' : '🔄 Reenviar E-mail de Verificação'}
        </button>

        <button onClick={onClose} className="btn-primary">
          Entendi
        </button>

        <p className="verification-help-text">
          Não recebeu o e-mail? Verifique sua pasta de spam ou aguarde alguns minutos antes de reenviar.
        </p>
      </div>
    </div>
  );
};

export default EmailVerificationModal;
